import { Head, useForm, Link } from '@inertiajs/react'
import { FormEvent } from 'react'

interface NewProps {
  errors?: {
    name?: string[]
    slug?: string[]
  }
}

export default function New({ errors }: NewProps) {
  const { data, setData, post, processing } = useForm({
    name: '',
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/workspaces')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Head title="New Workspace" />

      <nav className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Link href="/workspaces" className="text-xl font-bold text-gray-900">
              Doqubase
            </Link>
          </div>
        </div>
      </nav>

      <main className="mx-auto max-w-2xl px-4 py-12 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-gray-900">Create a New Workspace</h2>
        <p className="mt-2 text-sm text-gray-600">
          A workspace is where your team collaborates on documentation.
        </p>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Workspace Name
            </label>
            <input
              id="name"
              name="name"
              type="text"
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={data.name}
              onChange={(e) => setData('name', e.target.value)}
              placeholder="e.g. My Team Docs"
            />
            {errors?.name && <p className="mt-1 text-sm text-red-600">{errors.name[0]}</p>}
            {errors?.slug && <p className="mt-1 text-sm text-red-600">{errors.slug[0]}</p>}
          </div>

          <div className="flex items-center gap-4">
            <button
              type="submit"
              disabled={processing}
              className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50"
            >
              Create Workspace
            </button>
            <Link href="/workspaces" className="text-sm font-medium text-gray-600 hover:text-gray-900">
              Cancel
            </Link>
          </div>
        </form>
      </main>
    </div>
  )
}
